import { useState, useEffect } from "react";
import { apiFetch } from "../context/AppContext";

export function useDepartments() {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await apiFetch("/departments");
        if (res.ok && !cancelled) {
          const list = await res.json();
          setDepartments(sortDepartmentsByCode(Array.isArray(list) ? list : []));
        }
      } catch {
        if (!cancelled) setDepartments([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { departments, loading };
}

/** Auto-pick the only assigned department. Two or more stay as a dropdown. */
export function useAutoSelectAssignedDepartment({
  departmentId,
  setDepartmentId,
  departments,
  loading,
  enabled = true,
}) {
  useEffect(() => {
    if (!enabled || loading || departmentId || !departments?.length) return;
    if (departments.length === 1) {
      setDepartmentId(departments[0].id);
    }
  }, [enabled, loading, departmentId, departments, setDepartmentId]);
}

export function sortDepartmentsByCode(list) {
  return [...list].sort((a, b) => {
    const na = parseInt(String(a.code ?? ""), 10);
    const nb = parseInt(String(b.code ?? ""), 10);
    if (!Number.isNaN(na) && !Number.isNaN(nb)) return na - nb;
    return String(a.code ?? "").localeCompare(String(b.code ?? ""));
  });
}
